import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Paper, Typography, Grid, useTheme } from '@mui/material';
import {
  CreditCard,
  AccessTime,
  BarChart,
  CalendarToday,
} from '@mui/icons-material';

const AccountStatisticsWidget = () => {
  const theme = useTheme();
  const [stats, setStats] = useState([]);

  useEffect(() => {
    axios
      .get('https://fentrixbank.org/api/api/account-stats', { withCredentials: true })
      .then((res) => {
        const data = res.data;
        setStats([
          {
            icon: <CreditCard fontSize="small" />,
            label: 'Transaction Limit',
            value: `$${Number(data.transaction_limit).toLocaleString()}`,
            color: '#38bdf8',
          },
          {
            icon: <AccessTime fontSize="small" />,
            label: 'Pending Transactions',
            value: `$${Number(data.pending_transactions).toLocaleString()}`,
            color: '#fde68a',
          },
          {
            icon: <BarChart fontSize="small" />,
            label: 'Transaction Volume',
            value: `$${Number(data.transaction_volume).toLocaleString()}`,
            color: '#6ee7b7',
          },
          {
            icon: <CalendarToday fontSize="small" />,
            label: 'Account Age',
            value: data.account_age,
            color: '#e9d5ff',
          },
        ]);
      })
      .catch((err) => {
        console.error('Error fetching stats:', err);
      });
  }, []);

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 3,
        p: { xs: 2, md: 3 },
        width: '153%',     // ✅ always fill parent Grid
        height: '100%',    // ✅ match sibling heights
        mt: { xs: 2, md: 0 },
        backgroundColor: theme.palette.mode === 'dark' ? '#1e293b' : '#fff',
        boxShadow:
          theme.palette.mode === 'dark'
            ? 'none'
            : '0 1px 3px rgba(0,0,0,0.08)',
      }}
    >
      <Typography
        variant="subtitle1"
        fontWeight="bold"
        gutterBottom
        sx={{ fontSize: { xs: '0.95rem', md: '1rem' } }}
      >
        Account Statistics
      </Typography>

      <Box>
        {stats.map((item, index) => (
          <Grid
            container
            alignItems="center"
            spacing={2}
            key={index}
            sx={{
              py: 1,
              borderBottom:
                index !== stats.length - 1
                  ? `1px solid ${
                      theme.palette.mode === 'dark'
                        ? 'rgba(255,255,255,0.1)'
                        : 'rgba(0,0,0,0.08)'
                    }`
                  : 'none',
            }}
          >
            {/* Icon */}
            <Grid item>
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  borderRadius: '50%',
                  backgroundColor: item.color,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {item.icon}
              </Box>
            </Grid>

            {/* Label + Value */}
            <Grid item xs>
              <Typography
                variant="body2"
                fontWeight={500}
                sx={{ fontSize: { xs: '0.8rem', md: '0.9rem' } }}
              >
                {item.label}
              </Typography>
              <Typography
                variant="subtitle2"
                fontWeight="bold"
                sx={{ fontSize: { xs: '0.85rem', md: '0.95rem' } }}
              >
                {item.value}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Box>
    </Paper>
  );
};

export default AccountStatisticsWidget;